/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Brand colours for quotation, order and invoice PDFs, as the backend reads
 * them (backend/app/Services/company_branding.py): PearlCRM navy and blue by
 * default, and the pre-October-2026 default pair read as "never chosen".
 */

export const DEFAULT_MAIN = "#0F2E66";
export const DEFAULT_ACCENT = "#1565C8";
const PREVIOUS_DEFAULTS = ["#4759D1", "#E74C3C"];

export function normalizeHex(value, fallback) {
  const raw = String(value || "").trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(raw)) return raw.toUpperCase();
  if (/^[0-9A-Fa-f]{6}$/.test(raw)) return `#${raw.toUpperCase()}`;
  return fallback;
}

export const isHex = (value) => /^#?[0-9A-Fa-f]{6}$/.test(String(value || "").trim());

/** The colours a tenant's PDFs use, from /company/info. */
export function savedBrandColors(info) {
  const main = normalizeHex(info?.brand_primary_color, DEFAULT_MAIN);
  const accent = normalizeHex(info?.brand_secondary_color, DEFAULT_ACCENT);
  if (main === PREVIOUS_DEFAULTS[0] && accent === PREVIOUS_DEFAULTS[1]) return { main: DEFAULT_MAIN, accent: DEFAULT_ACCENT };
  return { main, accent };
}

function luminance(hex) {
  const n = normalizeHex(hex, "#000000").slice(1);
  const ch = (i) => {
    const c = parseInt(n.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * ch(0) + 0.7152 * ch(2) + 0.0722 * ch(4);
}

/** True when white text on this colour reads at 4.5:1 (the PDF uses white there). */
export function whiteTextReads(hex) {
  return 1.05 / (luminance(hex) + 0.05) >= 4.5;
}
